import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useLocation } from 'react-router-dom';
import Stripe from 'stripe'; 

const Payment = () => {
  const location = useLocation();
  const { paymentData } = location.state || {};
  const [savedPaymentData, setSavedPaymentData] = useState(null);

  useEffect(() => {
    const storedData = localStorage.getItem('paymentData');
    if (storedData) {
      setSavedPaymentData(JSON.parse(storedData));
    }
  }, []);

  return (
     
   <div className="main_wrap">   

     <Header />

     <div className="content-wrapper">           
         
            <div className="breadcrumb-wrap bg-f br-2">
               <div className="container">
                  <div className="breadcrumb-title text-center">
                     <h2>Payment</h2>
                     <ul className="breadcrumb-menu list-style">
                        <li><a href="/">Home </a></li>
                        <li>Payment</li>
                     </ul>
                  </div>
               </div>
            </div>

            <section id="tour_booking_submission" className="section_padding pb-75 pt-100">
                 <div className="container">
                     <div className="row justify-content-center payment_form"> 
                         <div className="col-xs-12 col-md-4">
                                <div className="panel panel-default">
                                    <div className="panel-body payment_details">
                                            <div className="row"> 
                                                <div className="col-xs-12">
                                                    <div className="form-group"> <label>CARD NUMBER</label>
                                                        <div className="input-group"> <input type="tel" className="form-control" placeholder="Valid Card Number" /> <span className="input-group-addon"><i class="ri-bank-card-2-line"></i></span> </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-xs-7 col-md-7">
                                                    <div className="form-group"> <label><span className="hidden-xs">EXPIRY</span> DATE</label> <input type="tel" className="form-control" placeholder="MM / YY" /> </div>
                                                </div>
                                                <div className="col-xs-5 col-md-5 pull-right">
                                                    <div className="form-group"> <label>CV CODE</label> <input type="tel" className="form-control" placeholder="CVC" /> </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-xs-12">
                                                    <div className="form-group"> <label>CARD OWNER</label> <input type="text" className="form-control" placeholder="Card Owner Name" /> </div>
                                                </div>
                                            </div>
                                            <div className="panel-footer">
                                                <div className="row"> 
                                                    <div className="col-xs-12 full_width"> <button className="btn style1">Confirm Payment</button> </div>
                                                </div>
                                            </div>

                                    </div>
                                    
                                </div>
                            </div>
                     </div>
                 </div>
             </section>
     </div>

     <Footer />  

    </div>

  );
};

export default Payment;
